module.exports = __webpack_public_path__ + "static/media/arrow-icon.f9b9f3df.svg";